import React, { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'
import { Navigate } from 'react-router-dom'

import { Loading } from 'components'

import { useAuth } from '../hooks'

export const SecuredRoute = ({ role, children }) => {
  const toast = useToast()
  const { auth, error, loading } = useAuth()

  useEffect(() => {
    if (error) {
      console.log(error)
      toast({
        status: 'error',
        title: 'Occoreu um erro',
        description: error
      })
    }
  }, [error, toast])

  if (loading || error) {
    return <Loading />
  }

  if (auth && auth.authorities.includes(role)) {
    return children
  } else {
    return <Navigate to='/login' />
  }
}

export default SecuredRoute
